export default __webpack_public_path__ + "static/Resume-CodySehl-68cf88edfa015f0a24172555dff80961.pdf";